import { Trans } from 'react-i18next';
import Modal from '~/components/modals/Modal/Modal';
import ModalTitle from '~/components/modals/Modal/ModalTitle';
import SimpleModalActions from '~/components/modals/Modal/SimpleModalActions';
import Text from '~/components/typographies/Text';
import { ModalProps } from '~/modals/Modal';
import ModalContent from '../Modal/ModalContent';

export interface ConfirmationModalProps extends ModalProps {
  action?: 'confirm' | 'destructive';
  cancelLabel?: string;
  confirmLabel: string;
  description: string;
  Icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  onConfirm: () => void | Promise<void>;
  title: string;
}

const ConfirmationModal = (props: ConfirmationModalProps) => {
  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      props.closeModal();
    }
  };

  const handleConfirm = async () => {
    await props.onConfirm();
    props.closeModal();
  };

  return (
    <Modal {...props} isAlert isOpen onOpenChange={handleOpenChange}>
      <ModalTitle Icon={props.Icon}>{props.title}</ModalTitle>

      <ModalContent>
        <Text variant="body2" weight="regular">
          <Trans>{props.description}</Trans>
        </Text>
      </ModalContent>

      <SimpleModalActions
        action={props.action}
        cancelLabel={props.cancelLabel}
        confirmLabel={props.confirmLabel}
        onConfirm={handleConfirm}
        onOpenChange={handleOpenChange}
      />
    </Modal>
  );
};

export default ConfirmationModal;
